import { useMemo } from 'react';
import { useMedia } from './useMedia';
import breakpoints, { sizes } from '../breakpoints';
import { getPx } from '../helpers/common';
import { byMediaBreakpoints } from '../helpers/media';
import { isDefined } from '../helpers/defined';
const getMediaQueries = props => {
  // Default size defines default value
  const defaultSize = sizes[0];

  // Rest of sizes to form media-queries array
  // Note: we need to reverse it since we're using min-width only and biggest screen  should go first
  const restSizes = sizes.slice(1).filter(size => isDefined(props[size])).reverse();
  const queries = restSizes.map(size => `(min-width: ${getPx(breakpoints[size].min)})`);
  const values = restSizes.map(size => props[size]);
  const defaultValue = props[defaultSize];
  return {
    queries,
    values,
    defaultValue
  };
};

/*
 * Returns calculated value according to media queries
 * Example:
 * const height = useMediaBreakpoints({ xs: 162, sm: 168, md: 180, xl: 184 })
 */
export const useMediaBreakpoints = (props, listenToChanges = false) => {
  const {
    queries,
    values,
    defaultValue
  } = useMemo(() => byMediaBreakpoints(getMediaQueries, false)(props), [props]);
  return useMedia(queries, values, defaultValue, listenToChanges);
};